import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { getPatientProfile } from 'src/store/modules/patient'
import {
  WALLET_HISTORY_TABLE_LOADER,
  setGamificationAchievements,
  setGamificationModules,
  setPatientGamificationActivities,
  setPatientGamificationActivitiesLoading,
  setPatientGamificationCompliance,
  setPatientGamificationLoader,
  setPatientGamificationMedal,
  setPatientGamificationRewardAchievements,
  setPatientGamificationRewardTasks,
  setPatientGamificationWallet,
  setPatientGamificationWalletHistory,
  setPatientMedicationCompliance
} from 'src/store/modules/patient/gamification'

import {
  GAMIFICATION_ACHIEVEMENTS_LIST,
  GAMIFICATION_MODULES,
  MEDICATION_TOTAL_COMPLIANCE,
  PATIENT,
  PATIENT_GAMIFICATION_ACTIVITIES
} from 'src/constants'
import patient from 'src/services/@core/API/routes/patients'

export const getPatientWallet =
  (config = {}) =>
  async (dispatch) => {
    try {
      const wallet = await patient.getPatientWallet(config)

      dispatch(setPatientGamificationWallet(wallet))
    } catch (err) {
      catchError(err)
    }
  }

export const getPatientWalletHistory =
  (config = {}) =>
  async (dispatch) => {
    dispatch(
      setPatientGamificationLoader({
        loader: WALLET_HISTORY_TABLE_LOADER,
        flag: true
      })
    )

    try {
      const { items = [], meta = {} } = await patient.getPatientWalletHistory(
        config
      )

      dispatch(setPatientGamificationWalletHistory(items))

      return meta
    } catch (err) {
      catchError(err)
      return err
    } finally {
      dispatch(
        setPatientGamificationLoader({
          loader: WALLET_HISTORY_TABLE_LOADER,
          flag: false
        })
      )
    }
  }

export const adjustPatientCurrency =
  (config = {}) =>
  async (dispatch) => {
    try {
      const wallet = await patient.adjustPatientCurrency(config)

      dispatch(setPatientGamificationWallet(wallet))
    } catch (err) {
      catchError(err)
    }
  }

export const getPatientRewardHistory =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { rewards } = await patient.getPatientRewardHistory(config)
      const tasks = rewards.filter((item) => item.isTask)
      const achievements = rewards.filter((item) => item.isAchievement)

      dispatch(setPatientGamificationRewardTasks(tasks))
      dispatch(setPatientGamificationRewardAchievements(achievements))
    } catch (err) {
      catchError(err)
      dispatch(setPatientGamificationRewardTasks([]))
      dispatch(setPatientGamificationRewardAchievements([]))
    }
  }

export const getPatientCompliance =
  (config = {}) =>
  async (dispatch) => {
    try {
      const compliance = await patient.getPatientCompliance(config)

      if (compliance[0]) {
        const { medal } = compliance[0]
        dispatch(setPatientGamificationMedal(medal || null))
      }

      dispatch(setPatientGamificationCompliance(compliance))
    } catch (err) {
      catchError(err)
      dispatch(setPatientGamificationCompliance([]))
    }
  }

export const getPatientActivitiesHistory =
  (query = {}, uuid) =>
  async (dispatch) => {
    dispatch(setPatientGamificationActivitiesLoading(true))
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: PATIENT_GAMIFICATION_ACTIVITIES,
          params: {
            uuid
          },
          query
        }
      })

      dispatch(setPatientGamificationActivities(items))
      return meta
    } catch (err) {
      catchError(err)
    } finally {
      dispatch(setPatientGamificationActivitiesLoading(false))
    }
  }

export const getGamificationModules = () => async (dispatch) => {
  try {
    const { items = [] } = await httpClient.request({
      method: 'get',
      url: {
        pathname: GAMIFICATION_MODULES
      }
    })

    dispatch(setGamificationModules(items))
  } catch (err) {
    catchError(err)
  }
}

export const getGamificationAchievementsList = () => async (dispatch) => {
  try {
    const { items = [] } = await httpClient.request({
      method: 'get',
      url: {
        pathname: GAMIFICATION_ACHIEVEMENTS_LIST
      }
    })

    dispatch(setGamificationAchievements(items))
  } catch (err) {
    catchError(err)
  }
}

export const getPatientMedicationCompliance = (query) => async (dispatch) => {
  try {
    const items = await httpClient.request({
      method: 'get',
      url: {
        pathname: MEDICATION_TOTAL_COMPLIANCE,
        query
      }
    })

    dispatch(setPatientMedicationCompliance(items))
  } catch (err) {
    catchError(err)
  }
}

export const setPatientGamificationEnable =
  (id, gamificationEnabled) => async (dispatch) => {
    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: PATIENT,
          params: {
            id
          }
        },
        payload: { gamificationEnabled }
      })

      await dispatch(getPatientProfile(id))
    } catch (err) {
      catchError(err)
    }
  }
